export const fetchEnvironmentVariableConfigActionSuccess = data => ({ type: 'FETCH_ENVIRONMENT_VARIABLE_CONFIG_SUCCESS', data });
export const fetchEnvironmentVariableConfigActionError = error => ({ type: 'FETCH_ENVIRONMENT_VARIABLE_CONFIG_ERROR', error });
